import { render, staticRenderFns } from "./LogoLarge.vue?vue&type=template&id=3af72b9e&scoped=true&"
import script from "./LogoLarge.vue?vue&type=script&lang=js&"
export * from "./LogoLarge.vue?vue&type=script&lang=js&"
import style0 from "./LogoLarge.vue?vue&type=style&index=0&id=3af72b9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af72b9e",
  null
  
)

export default component.exports